import { defineMessages } from 'react-intl';

export default defineMessages({
  home: {
    id: 'home',
    defaultMessage: 'Home',
  },
  page: {
    id: 'gold.transactionlog.page',
    defaultMessage: 'Transaction Log',
  },
  title: {
    id: 'gold.transactionlog.title.detail',
    defaultMessage: 'Account Details',
  },
  transition: {
    id: 'gold.transactionlog.transition.detail',
    defaultMessage: 'Transaction Transition History',
  },
  table: {
    merchantID: {
      id: 'gold.transactionlog.table.detail.mid',
      defaultMessage: 'Merchant Order ID',
    },
  },
});
